import React from 'react';

export const ProfileCompletionProgressBar = ({ completeBkgColour, overallBkgColour, percentage }: any) => {
  return (
    <div
      className={`${overallBkgColour} mt-6 md:mt-1 w-[18rem] mx-auto h-12 relative z-0 rounded-full border-2 border-tertiary overflow-hidden`}
    >
      <div
        style={{ right: `${100 - percentage}%` }}
        className={`${completeBkgColour} absolute h-full rounded-full w-[18rem]`}
      ></div>
      <div className="absolute flex h-full items-center justify-center text-center md:text-sm text-xs text-gray tracking-wider w-full z-2">
        PROFILE COMPLETION
        <span className="ml-2 font-bold md:text-lg text-sm   tracking-wide">{percentage}%</span>
      </div>
    </div>
  );
};
